import { createReducer } from 'utils/redux'

const defaultState = {
  teams: null,
  availabilities: null,
}

// receive all teams objects
const receiveTeamsHandler = ({ draft, action }) => {
  const teams = action.payload
  draft.teams = teams
}

// receive all team availability objects
const receiveTeamAvailabilitiesHandler = ({ draft, action }) => {
  const availabilities = action.payload
  draft.availabilities = availabilities
}

// replaces team in store with a new team object by id
const receiveUpdatedTeamHandler = ({ draft, action }) => {
  const updatedTeam = action.payload
  const filteredTeams = draft.teams.filter((team) => team.id !== updatedTeam.id)
  draft.teams = [...filteredTeams, updatedTeam]
}

// removes list of teams object from the redux store
const removeTeamsHandler = ({ draft, action }) => {
  const archievedTeamIds = action.payload.map((team) => team.id)
  draft.teams = draft.teams.filter(
    (team) => !archievedTeamIds.includes(team.id)
  )
}

// replaces availability in store with a new availability object by id
const receiveUpdatedTeamAvailabilityHandler = ({ draft, action }) => {
  const updatedAvailability = action.payload
  const filteredAvailabilities = draft.availabilities.filter(
    (availability) => availability.id !== updatedAvailability.id
  )
  draft.availabilities = [...filteredAvailabilities, updatedAvailability]
}

const actions = {
  RECEIVE_TEAMS: receiveTeamsHandler,
  RECEIVE_TEAM_AVAILABILITIES: receiveTeamAvailabilitiesHandler,
  RECEIVE_UPDATED_TEAM: receiveUpdatedTeamHandler,
  REMOVE_TEAMS: removeTeamsHandler,
  RECEIVE_UPDATED_TEAM_AVAILABILITY: receiveUpdatedTeamAvailabilityHandler,
}

const teamsReducer = createReducer(defaultState, actions)

export default teamsReducer
